import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { actionCreators } from '../../store/Login';
import { bindActionCreators } from 'redux';
import { UserRoles, EditState } from '../shared/enums';
import { Col, Row } from 'react-bootstrap';
import { toast } from 'react-toastify';
import "./Home.css";

class DailyNotesList extends React.Component {
    displayName = DailyNotesList.name;

    render() {
        var items = [];
        var items2 = [];

        if (this.props.editMode === EditState.List) {
            items = this.props.combinedDailyNotes;
        }

        if (this.props.editMode === EditState.Edit && this.props.userRole !== "GroupStoreBuyer") {
            items = this.props.dailyNotes;
            items2 = this.props.groupBuyerDailyNotes;
        }

        if (this.props.editMode === EditState.Edit && this.props.userRole === "GroupStoreBuyer") {
            items = this.props.groupBuyerDailyNotes;
        }

        var item = items.map((item, index) => {
            return (
                <React.Fragment key={index}>
                    {this.props.userRole !== "GroupStoreBuyer" &&
                    <DailyNotesListItem
                        editMode={this.props.editMode}
                        key={index}
                        index={index}
                        item={item}
                        onRemoveItem={this.props.onRemoveItem}
                        onChangeText={this.props.onChangeText}
                        userRole={this.props.userRole}
                        isCopyHome={this.props.isCopyHome}
                        toggleAddToCopyHome={this.props.toggleAddToCopyHome}
                        setIsChecked={this.props.setIsChecked}
                    />
                    }
                    {this.props.userRole === "GroupStoreBuyer" &&
                        <DailyNotesListItem
                            editMode={this.props.editMode}
                            key={index}
                            index={index}
                            item={item}
                            onRemoveItem={this.props.onRemoveGroupItem}
                            onChangeText={this.props.onChangeGroupText}
                            userRole={this.props.userRole}
                            isCopyHome={false}
                            toggleAddToCopyHome={this.props.toggleAddToCopyHome}
                            setIsChecked={this.props.setIsChecked}
                        />
                    }
                </React.Fragment>
            );
        });

        var item2 = items2.map((item, index) => {
            return (
                <React.Fragment>             
                    <DailyNotesListItem
                        editMode={this.props.editMode}
                        key={index}
                        index={index}
                        item={item}
                        onRemoveItem={this.props.onRemoveGroupItem}
                        onChangeText={this.props.onChangeGroupText}
                        userRole={this.props.userRole}
                    />                  
                </React.Fragment>
            );
        });

        return (
            <ul className="list-group">{item} {item2}</ul>
        );
    }
}

class DailyNotesListItem extends React.Component {
    displayName = DailyNotesHeader.name;
 
    render() {
        return (
            <div>
                {this.props.editMode === EditState.Edit &&
                    <li className="list-group-item" style={{ backgroundColor: ((this.props.item.isGroupNote) ? 'rgb(66, 207, 115)' : '') }}>
                        <Row>
                            <Col xs={11}>
                                <textarea
                                    className="form-control HomeItemInput"
                                    value={this.props.item.text}
                                    placeholder="Enter Note"
                                    onChange={(e) => this.props.onChangeText(this.props.index, e)}
                                />
                            </Col>
                            <Col xs={1}>
                                <button
                                    className="pull-right btn btn-outline-danger btn-sm deleteButton"
                                    onClick={(e) => this.props.onRemoveItem(this.props.index, e)}
                                >
                                    X
                                </button>
                            </Col>
                        </Row>
                    </li>
                }
                {this.props.editMode === EditState.List &&
                    <li className="list-group-item" style={{ backgroundColor: ((this.props.item.isGroupNote) ? 'rgb(66, 207, 115)': '') }}>
                        <div className="HomeItemInput">
                            {this.props.isCopyHome && !this.props.item.isGroupNote &&
                                <React.Fragment>
                                    <label htmlFor="test"/>
                                    <label className="homeCheckbox">
                                    <input type="checkbox" name="test" checked={this.props.item.isChecked} onChange={(e) => this.props.setIsChecked(this.props.item)} />
                                        <span/>
                                    </label>
                                </React.Fragment>
                            }
                            {this.props.item.text}
                        </div>
                    </li>
                }
            </div>
        );
    }
}

class DailyNotesHeader extends React.Component {
    displayName = DailyNotesHeader.name;

    render() {
        return (
            <div className="ogcText">
                <div style={{ display: 'inline-block', marginLeft: '2%', fontSize: 'larger' }}>
                    <span className="homeHeader">DAILY NOTES</span>
                </div>
                {!this.props.isCopyHome &&
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        {this.props.showEditForm && this.props.editMode === EditState.List &&
                            <button className="ogcButton btn-std-size" onClick={this.props.onClickEdit}>Edit</button>
                        }
                        {this.props.showEditForm && this.props.editMode === EditState.Edit &&
                            <React.Fragment>
                                <button className="ogcButton btn-std-size" onClick={this.props.onClickAdd}>Add</button>
                                <button className={(this.props.isDirty) ? "ogcButton btn-std-size" : "ogcDisabledButton btn-std-size"} onClick={this.props.onClickSubmit} disabled={!this.props.isDirty}>Submit</button>
                                <button className="ogcButton btn-std-size" onClick={this.props.onClearItems}>Clear All</button>
                                <button className="ogcButton ogcButton-brown btn-std-size" onClick={this.props.onClickCancel}>Cancel</button>
                            </React.Fragment>
                        }
                    </div>
                }
                {this.props.isCopyHome &&
                    <div style={{ display: 'inline-block', float: 'right' }}>
                        <button className="ogcButton btn-std-size" onClick={this.props.onClickSelectAll}>Select All</button>
                        <button className="ogcButton btn-std-size" onClick={this.props.onClickUnselectAll}>Unselect All</button>
                    </div>
                }
            </div>
        );
    }
}

class DailyNotes extends React.Component {
    displayName = DailyNotes.name;

    constructor(props) {
        super(props);

        this.responseStatus = 200;
        this.showEditForm = this.props.isAuthenticated && this.props.isEditHome &&
            (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep || this.props.userRole === UserRoles.GroupStoreBuyer);

        this.state = {
            originalDailyNotes: [],
            dailyNotes: [],
            originalGroupBuyerDailyNotes: [],
            groupBuyerDailyNotes: [],
            combinedDailyNotes: [],
            load: false,
            editMode: EditState.List,
            checkedNotes: []
        };
    }

    componentDidMount = async () => {
        const fetchConfig = {
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        };

        this.setState({ load: true });
        const response = await fetch('api/Home/DailyNotes/', fetchConfig);
        if (response.ok) {
            let data = await response.json();

            var cdn = [];

            for (var i = 0; i < data.dailyNotes.length; i++) {
                var dn = data.dailyNotes[i];
                dn.isGroupNote = false;

                cdn.push(dn);
            }

            for (var i2 = 0; i2 < data.groupBuyerDailyNotes.length; i2++) {
                var dn2 = data.groupBuyerDailyNotes[i2];
                dn2.isGroupNote = true;

                cdn.push(dn2);
            }

            var dailyNotes = data.dailyNotes;

            dailyNotes.map((obj) => {
                obj.isChecked = false;
                return obj;
            });

            this.setState({ dailyNotes: data.dailyNotes, groupBuyerDailyNotes: data.groupBuyerDailyNotes, combinedDailyNotes: cdn, load: false });
        }
        else if (response.status === 401) {
            this.props.signOut();
        }
        else {
            var err = await response.text();
            console.log(`Failed to load Daily Notes: ${err}.`);
            toast.error("Failed to load Daily Notes.");
        }
    };

    onRemoveItem = (idx,e) => {
        var items = this.state.dailyNotes;
        items.splice(idx, 1);
        this.setState({ dailyNotes: items });
        this.props.setDirty(true);
    }

    onRemoveGroupItem = (idx, e) => {
        var items = this.state.groupBuyerDailyNotes;
        items.splice(idx, 1);
        this.setState({ groupBuyerDailyNotes: items });
        this.props.setDirty(true);
    }

    onClearItems = () => {
        if (this.props.userRole === UserRoles.GroupStoreBuyer) {
            this.setState({ groupBuyerDailyNotes: [] });
        }
        else {
            this.setState({ dailyNotes: [], groupBuyerDailyNotes: [] });
        }
        this.props.setDirty(true);
    }

    onChangeText = (idx, e) => {
        let items = this.state.dailyNotes;
        items[idx].text = e.target.value;
        this.setState({ dailyNotes: items });
        this.props.setDirty(true);
    }

    onChangeGroupText = (idx, e) => {
        let items = this.state.groupBuyerDailyNotes;
        items[idx].text = e.target.value;
        this.setState({ groupBuyerDailyNotes: items });
        this.props.setDirty(true);
    }

    onClickSubmit = async () => {

        var data = {
            "DailyNotes": this.state.dailyNotes,
            "GroupBuyerDailyNotes": this.state.groupBuyerDailyNotes
        };

        const fetchConfig = {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'Accept': 'application/json',
                'Content-Type': 'application/json; charset=utf-8'
            },
            body: JSON.stringify(data)
        };

        const response = await fetch('api/home/dailynotes/', fetchConfig);
        if (response.ok) {
            toast.success("Daily Notes updated.");

            var cdn = [];

            for (var i = 0; i < this.state.dailyNotes.length; i++) {
                var dn = this.state.dailyNotes[i];
                dn.isGroupNote = false;

                cdn.push(dn);
            }

            for (var i2 = 0; i2 < this.state.groupBuyerDailyNotes.length; i2++) {
                var dn2 = this.state.groupBuyerDailyNotes[i2];
                dn2.isGroupNote = true;

                cdn.push(dn2);
            }

            this.setState({ editMode: EditState.List, combinedDailyNotes: cdn }); 
            this.props.setDirty(false);
        }
        else if (response.status === 401) {
            toast.error("Unauthorized.");
            this.props.signOut();
        }
        else {
            toast.error(`Error saving Daily Notes.`);
            console.log(`Error saving Daily Notes: ${await response.text()}.`);
        }
    }

    onClickEdit = (e) => {
        const deepCopyNotes = this.state.dailyNotes.map(a => Object.assign({}, a));
        const deepCopyGroupNotes = this.state.groupBuyerDailyNotes.map(a => Object.assign({}, a));
        this.setState({ editMode: EditState.Edit, originalDailyNotes: deepCopyNotes, originalGroupBuyerDailyNotes: deepCopyGroupNotes });
    }

    onClickCancel = (e) => {
        this.setState({ editMode: EditState.List, dailyNotes: this.state.originalDailyNotes, groupBuyerDailyNotes: this.state.originalGroupBuyerDailyNotes });
        this.props.setDirty(false);
    }

    onClickAdd = (e) => {
        if (this.props.userRole === UserRoles.Administrator || this.props.userRole === UserRoles.SalesRep) {
            var items = this.state.dailyNotes;
            items.push({
                index: this.state.dailyNotes.length + 1,
                text: ''
            });
            this.setState({ editMode: EditState.Edit, dailyNotes: items });
            this.props.setDirty(true);
        }

        if (this.props.userRole === UserRoles.GroupStoreBuyer) {
            var items2 = this.state.groupBuyerDailyNotes;
            items2.push({
                index: this.state.groupBuyerDailyNotes.length + 1,
                text: ''
            });
            this.setState({ editMode: EditState.Edit, groupBuyerDailyNotes: items2 });
            this.props.setDirty(true);
        }  
    }

    setIsChecked = async (item) => {
        var note = item;
        note.isChecked = !note.isChecked;

        await this.setState({ item });

        var dailyNotes = this.state.dailyNotes.filter(function (n) { return n.isChecked; });

        this.props.toggleAddToCopyHome('dailyNotes', dailyNotes);
    }

    onClickSelectAll = async () => {
        var dailyNotes = this.state.dailyNotes;

        dailyNotes.map((obj) => {
            obj.isChecked = true;
            return obj;
        });

        await this.setState({ dailyNotes });
        this.props.toggleAddToCopyHome('dailyNotes', dailyNotes);
    }

    onClickUnselectAll = async () => {
        var dailyNotes = this.state.dailyNotes;

        dailyNotes.map((obj) => {
            obj.isChecked = false;
            return obj;
        });

        await this.setState({ dailyNotes });
        this.props.toggleAddToCopyHome('dailyNotes', []);
    }

    render() {
        return (
            <div>
                <DailyNotesHeader
                    editMode={this.state.editMode}
                    showEditForm={this.showEditForm}
                    onClickEdit={this.onClickEdit}
                    onClickCancel={this.onClickCancel}
                    onClickAdd={this.onClickAdd}
                    onClickSubmit={this.onClickSubmit}
                    isCopyHome={this.props.isCopyHome}
                    onClearItems={this.onClearItems}
                    onClickSelectAll={this.onClickSelectAll}
                    onClickUnselectAll={this.onClickUnselectAll}
                    isDirty={this.props.isDirty}
                />
                <div className="dailyNotes">
                    <DailyNotesList
                        dailyNotes={this.state.dailyNotes}
                        groupBuyerDailyNotes={this.state.groupBuyerDailyNotes}
                        combinedDailyNotes={this.state.combinedDailyNotes}
                        onRemoveItem={this.onRemoveItem}
                        onRemoveGroupItem={this.onRemoveGroupItem}
                        editMode={this.props.isCopyHome === true ? EditState.List : this.state.editMode}
                        onChangeText={this.onChangeText}
                        onChangeGroupText={this.onChangeGroupText}
                        userRole={this.props.userRole}
                        isCopyHome={this.props.isCopyHome}
                        toggleAddToCopyHome={this.props.toggleAddToCopyHome}
                        setIsChecked={this.setIsChecked}
                    />
                </div>
            </div>
        );
    }
}

export default withRouter(connect(state => state.login,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(DailyNotes));


// WEBPACK FOOTER //
// ./src/components/Home/DailyNotes.js